<template>
  <div>
    <toolbar/>
    <div class="containerFull">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Toolbar from '@/components/Nav/Toolbar';

export default {
  name: 'dashboard-home',
  data() {
    return {
      msg: 'Welcome to Your Vue.js App',
    };
  },
  mounted() {},
  methods: {},
  components: {
    Toolbar,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Home.vue